import type { FleetLoadRow } from "@/types/reports";

/**
 * Whether the pallet dimension carries any signal across the result set. The
 * tenant doesn't track pallets when every vehicle reports zero pallets used and
 * no (or zero) pallet capacity — in that case the whole column is em-dashes and
 * masquerades as a data bug, so it is hidden (TASK-3848). The column reappears
 * automatically as soon as any vehicle has pallet data.
 *
 * Kept in a non-component module so the table/tab components only export
 * components (satisfies the react-refresh/only-export-components lint rule).
 */
export function hasPalletData(rows: FleetLoadRow[]): boolean {
  return rows.some(
    (row) =>
      row.pallets_used > 0 ||
      (row.pallets_capacity !== null &&
        Number.isFinite(row.pallets_capacity) &&
        row.pallets_capacity > 0),
  );
}
